// Parses a serialized text decoration config (data-text-decoration-config).
// Returns the config object, or null when blank, malformed, or not an object.
export function parseTextDecorationConfig(raw) {
  if (!raw) return null
  try {
    const config = typeof raw === 'string' ? JSON.parse(raw) : raw
    return config && typeof config === 'object' && !Array.isArray(config)
      ? config
      : null
  } catch (e) {
    console.error('Failed to parse text decoration config:', e)
    return null
  }
}
